export default "__VITE_ASSET__ByE5qZQH__"